'use strict';

module.exports =  {
  statusColor: '#5CE592',
  statusInactiveColor: '#FC6F6F',
  unMaskColor: '#000000',
  unMaskTime: 1400,
  zxcvbnSrc: 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/1.0/zxcvbn.min.js',
  strengthLang: ['Weak', 'Okay', 'Good', 'Strong', 'Great']
}



// WEBPACK FOOTER //
// ./src/vendor/react-ux-password-field/src/js/config.js